import React, { useState } from 'react';
import {ReactComponent as ActiveIcon} from '../../components/svgs/activeIcon.svg'
import {ReactComponent as LaundryMachineIcon} from '../../components/svgs/laundrymachineicon.svg';
import {ReactComponent as ShippingBoxIcon} from '../../components/svgs/shippingboxicon.svg';
import {ReactComponent as CloudCheckIcon} from '../../components/svgs/cloudCheckIcon.svg';
import {ReactComponent as SearchIcon} from '../../components/svgs/searchicon.svg';
import {ReactComponent as FilterIcon} from '../../components/svgs/filterIcon.svg';
import {ReactComponent as ExportIcon} from '../../components/svgs/exportIcon.svg';

import { Link } from 'react-router-dom';
import DropdownSVG from '../../components/OrderDropdown';

const options = [
    { label: 'Edit Order', link: '#' },
    { label: 'Duplicate Order', link: '#' },
    { label: 'Print Details', link: '#' },
    { label: 'Archive Orders', link: '#' }
  ];



const EmployeeOrderTab = () => {

    const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      title: 'In Laundry',
      icon: <LaundryMachineIcon/>,
      counterBadgeNumber: 6,
      tableData: [
        { orderNo: '#23', pickupDate: '06/27/23', noOfBags: '3',  size: 119, viewButton: '/manager/order-details' },
        { orderNo: '#23', pickupDate: '07/17/13', noOfBags: '16', size: 119, viewButton: '/manager/order-details' },
        { orderNo: '#23', pickupDate: '06/27/23', noOfBags: '45', size: 119, viewButton: '/manager/order-details' },
        { orderNo: '#23', pickupDate: '07/17/13', noOfBags: '10', size: 119, viewButton: '/manager/order-details' },
        { orderNo: '#23', pickupDate: '06/27/23', noOfBags: '10', size: 119, viewButton: '/manager/order-details' },

      ]
    },
    {
      title: 'Ready for pickup',
      icon: <ShippingBoxIcon/>,
      counterBadgeNumber: 6,
      tableData: [
        { orderNo: '#23', pickupDate: '06/27/23', noOfBags: '3',  size: 119, viewButton: '/manager/order-details' },
        { orderNo: '#23', pickupDate: '07/17/13', noOfBags: '16', size: 119, viewButton: '/manager/order-details' },
        { orderNo: '#23', pickupDate: '06/27/23', noOfBags: '45', size: 119, viewButton: '/manager/order-details' },
      ]
    },
    {
      title: 'Picked up',
      icon: <CloudCheckIcon/>,
      counterBadgeNumber: 6,
      tableData: [
        { orderNo: '#23', pickupDate: '07/17/13', noOfBags: '16', size: 119, viewButton: '/manager/order-details' },
        { orderNo: '#23', pickupDate: '06/27/23', noOfBags: '45', size: 119, viewButton: '/manager/order-details' },
      ]
    }
  ];


  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  return (
    <>
    <div className="tab-container">

        <div className="tab-titles">
        {tabs.map((tab, index) => (
            <div
            key={index}
            className={`tab-title ${activeTab === index ? 'active' : ''}`}
            onClick={() => handleTabClick(index)}
            >
            <div className={`tab-icon ${activeTab === index ? 'active' : ''}`}>
                {React.cloneElement(tab.icon, {
                className: activeTab === index ? 'active-icon' : ''
                })}
            </div>
            <div className={`tab-label ${activeTab === index ? 'active' : ''}`}>{tab.title}</div>
            <div className={`tab-label counter-badge-number ${activeTab === index ? 'active' : ''}`}>{tab.counterBadgeNumber}</div>
            </div>
        ))}
        </div>

        <section className='flex search-filter-section mt-4 mb-4 ml-4'>
            <section>
                <form action="">
                <label htmlFor="" className="flex flex-col order-search-input">
                    <SearchIcon className='order-search-icon search-icon'/>
                    <input type="text" placeholder="Search" className="mt-2"/>
                </label>
                </form>
            </section>
            <section className='flex gap-10 mt-10 ml-20'>
                <div className='flex gap-4'>
                    <FilterIcon/>
                    <p className='filter-section-text'>Filter</p>

                </div>
                <div className='flex gap-4'>
                    <ExportIcon/>
                    <p className='filter-section-text'>Export as csv</p>
                    
                </div>
            </section>
        </section>    
            

      <div className="tab-content">
        {tabs.map((tab, index) => (
          <div key={index} className={`tab-pane ${activeTab === index ? 'active' : ''}`}>
            <table className="custom-table custom-order-table">

              <thead>
                <tr className='table-head'>
                  <th className=''>
                    Order No.
                    <span className="filter-icon">
                      <ActiveIcon />
                      
                    </span>
                  </th>
                  <th className=''>
                    Pick-up-date
                    <span className="filter-icon">
                    <ActiveIcon className=''/>
                    </span>
                  </th>
                  <th>
                    No of Bags
                    <span className="filter-icon">
                      <ActiveIcon />
                    </span>
                  </th>
                  <th>
                    Size (lbs)
                    <span className="filter-icon">
                        <ActiveIcon />
                    </span>
                  </th>
                  
                </tr>
              </thead>

              <tbody className='table-body'>
                {tab.tableData.map((data, dataIndex) => (
                  <tr key={dataIndex} className='table-row'>
                    <td className='table-data-1'>
                      {data.orderNo}
                      
                    </td>
                   
                    <td className='table-data-1'>
                      {data.pickupDate}
                      <div className='customer-rep'>{data.commercialCustomerRep}</div>
                    </td>
                   
                    <td className='table-data'>
                      {data.noOfBags}
                    
                    </td>
                    <td className='table-data'>
                      {data.size}
                   
                    </td>
                   
                    <td>
                        <Link to={data.viewButton} className='view-btn'>View</Link>
                    </td>
                    <td>
                    <DropdownSVG options={options} className="my-dropdown" />
                    </td>
                    
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </div>
    </>
  )
}

export default EmployeeOrderTab